import * as React from "react"

import { cn } from "@/lib/utils"

const InputBase = React.forwardRef<HTMLInputElement, React.ComponentProps<"input">>(
  ({ className, type, ...props }, ref) => {
    return (
      <input
        type={type}
        className={cn(
          "flex h-9 w-full rounded-md border border-input bg-transparent px-3 py-1 text-base shadow-sm transition-colors file:border-0 file:bg-transparent file:text-sm file:font-medium file:text-foreground placeholder:text-muted-foreground focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-ring disabled:cursor-not-allowed disabled:opacity-50 md:text-sm",
          className
        )}
        ref={ref}
        {...props}
      />
    )
  }
)
InputBase.displayName = "Input"

// --- uiv2: conditional Intui swap (build-time resolved by Vite) ---
import { IntuiInput } from '@/components/intueri/IntuiInput/IntuiInput'

const _uiv2 = import.meta.env.VITE_UIV2 === 'true'

// Lazy proxy: wraps Intui access in a render function to avoid TDZ errors from circular ESM imports.
const Input = _uiv2
  ? React.forwardRef<HTMLInputElement, React.ComponentProps<"input">>((props, ref) => {
      // Dynamic-dispatch cast: IntuiInput's prop signature differs slightly from
      // shadcn Input's, but at runtime it accepts the same DOM input props.
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      const Comp = IntuiInput as any
      return <Comp ref={ref} {...props} />
    }) as typeof InputBase
  : InputBase

export { Input, InputBase }
